var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"d-flex justify-content-between align-items-center w-100 px-3",attrs:{"to":_vm.to}},[_c('fa-icon',{attrs:{"icon":['fal', _vm.icon]}}),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }